import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { initialTopographicCodesModalState, IContentTopographicCodesGrid } from '@/modules/configurationModule/detail/samples/topography/TopographicCodes.models'

@Component
export default class TopographicCodesModal extends Vue {
    @Ref() readonly topographicCodesModal!: any
    @Prop(String) readonly actionTitle!: string
    @Emit()
    update(topography: IContentTopographicCodesGrid[]): IContentTopographicCodesGrid[] {
        return topography
    }
    @Emit()
    create(topography: IContentTopographicCodesGrid) {
        return topography
    }

    private state: IContentTopographicCodesGrid
    constructor() {
        super()
        this.state = initialTopographicCodesModalState()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const modelValidated = !!this.state.code && !!this.state.description
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    async show(selectedRow: IContentTopographicCodesGrid): Promise<void> {
        this.state = initialTopographicCodesModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.state = { ...selectedRow }
        }
        this.topographicCodesModal.show()
    }

    hide() { this.topographicCodesModal.hide() }

    actionModal() {
        if (this.state?.id) {
            this.update([this.state])
        } else {
            this.create(this.state)
        }
    }
}
